<!-- src/views/apps/weishop/components/Modal/AreasModal/AreasModal.vue -->
<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :width="'720px'"
    :close-on-click-modal="false"
    :before-close="handleCancel"
    @open="init"
  >
    <div v-loading="isLoading" element-loading-text="加载中...">
      <div class="areas-content clearfix">
        <!-- 未选择区域 -->
        <div class="areas-left fl-l">
          <h2 class="areas-title clearfix">
            <span class="fl-l">地区选择：</span>
            <a
              v-if="Object.keys(unSelected).length > 0"
              class="areas-flip fl-r"
              @click="handleSelectAll"
            >全选</a>
          </h2>
          <div class="areas-list">
            <ul class="areas-list-body">
              <li
                class="areas-item"
                :class="{ 'show-children': !province.isHideChildren }"
                v-for="(province, pidx) in unSelected"
                :key="pidx"
              >
                <div class="text clearfix" @click="handleActive(province)">
                  <i
                    class="el-icon-arrow-right icon"
                    :class="{ 'rotate-90': !province.isHideChildren }"
                  ></i>
                  <span class="item-title fl-l">{{ province.name }}</span>
                  <a class="item-flip fl-r" @click.stop="handleSelected('province', province)">选择</a>
                </div>
                <ul v-show="!province.isHideChildren" class="areas-sublist">
                  <li class="areas-item" v-for="(city, cidx) in province.city" :key="cidx">
                    <div class="text clearfix">
                      <span class="item-title fl-l">{{ city.name }}</span>
                      <a class="item-flip fl-r" @click.stop="handleSelected('city', city)">选择</a>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <!-- 已选择区域 -->
        <div class="areas-right fl-r">
          <h2 class="areas-title">已选择：</h2>
          <div class="areas-list">
            <ul class="areas-list-body">
              <li
                class="areas-item"
                :class="{ 'show-children': !province.isHideChildren }"
                v-for="(province, pidx) in selected"
                :key="pidx"
              >
                <div class="text clearfix" @click="handleActive(province)">
                  <i
                    class="el-icon-arrow-right icon"
                    :class="{ 'rotate-90': !province.isHideChildren }"
                  ></i>
                  <span class="item-title fl-l">{{ province.name }}</span>
                  <a class="item-flip fl-r" @click.stop="handleUnSelected('province', province)">删除</a>
                </div>
                <ul v-show="!province.isHideChildren" class="areas-sublist">
                  <li class="areas-item" v-for="(city, cidx) in province.city" :key="cidx">
                    <div class="text clearfix">
                      <span class="item-title fl-l">{{ city.name }}</span>
                      <a class="item-flip fl-r" @click.stop="handleUnSelected('city', city)">删除</a>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :loading="isLoading" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
  import RegionModel from '@/util/weishop/Region'
import { inArray } from '@/util/weishop/util'

export default {
  name: 'AreasModal',
  data() {
    return {
      title: '选择地区',
      visible: false,
      isLoading: false,
      regions: [],
      citysCount: null,
      custom: {},
      selectedCityIds: [],
      excludedCityIds: [],
      unSelected: {},
      selected: {}
    }
  },
  created() {
    // 获取地区数据
    RegionModel.getTreeData().then(data => {
      this.regions = data
    })
    // 城市总数
    RegionModel.getCitysCount().then(count => {
      this.citysCount = count
    })
  },
  methods: {
    handle(custom, selectedCityIds = [], excludedCityIds = []) {
      this.visible = true
      this.custom = custom
      this.selectedCityIds = selectedCityIds
      this.excludedCityIds = excludedCityIds
      this.init()
    },
    init() {
      this.initUnSelectedData()
      this.initSelectedData()
    },
    initUnSelectedData() {
      const { unSelected, regions, selectedCityIds, excludedCityIds } = this
      const data = _.cloneDeep(regions)
      const newUnSelected = {}
      for (const pidx in data) {
        const province = data[pidx]
        const cityList = []
        for (const cidx in province.city) {
          const cityItem = province.city[cidx]
          if (!inArray(cityItem.id, selectedCityIds) && !inArray(cityItem.id, excludedCityIds)) {
            cityList.push(cityItem)
          }
        }
        if (cityList.length) {
          province.city = cityList
          const isHideChildren = unSelected[pidx] ? unSelected[pidx].isHideChildren : true
          newUnSelected[pidx] = { ...province, isHideChildren }
        }
      }
      this.unSelected = newUnSelected
    },
    initSelectedData() {
      const { selected, regions, selectedCityIds } = this
      const data = _.cloneDeep(regions)
      const newSelected = {}
      for (const pidx in data) {
        const province = data[pidx]
        const cityList = []
        for (const cidx in province.city) {
          const cityItem = province.city[cidx]
          if (inArray(cityItem.id, selectedCityIds)) {
            cityList.push(cityItem)
          }
        }
        if (cityList.length) {
          province.city = cityList
          const isHideChildren = selected[pidx] ? selected[pidx].isHideChildren : true
          newSelected[pidx] = { ...province, isHideChildren }
        }
      }
      this.selected = newSelected
    },
    handleActive(item) {
      item.isHideChildren = !item.isHideChildren
    },
    handleSelected(type, item) {
      const newCityIds = []
      if (type === 'province') {
        for (const cidx in item.city) {
          newCityIds.push(item.city[cidx].id)
        }
      } else if (type === 'city') {
        newCityIds.push(item.id)
      }
      this.selectedCityIds = this.selectedCityIds.concat(newCityIds)
      this.init()
    },
    handleUnSelected(type, item) {
      const newCityIds = []
      if (type === 'province') {
        for (const cidx in item.city) {
          newCityIds.push(item.city[cidx].id)
        }
      } else if (type === 'city') {
        newCityIds.push(item.id)
      }
      this.selectedCityIds = _.difference(this.selectedCityIds, newCityIds)
      this.excludedCityIds = _.difference(this.excludedCityIds, newCityIds)
      this.init()
    },
    handleSelectAll() {
      const { selectedCityIds, unSelected } = this
      const newCityIds = []
      for (const pidx in unSelected) {
        const province = unSelected[pidx]
        for (const cidx in province.city) {
          const cityItem = province.city[cidx]
          newCityIds.push(cityItem.id)
        }
      }
      this.selectedCityIds = selectedCityIds.concat(newCityIds)
      this.init()
    },
    handleSubmit() {
      if (this.selectedCityIds.length < 1) {
        this.$message.error('请至少选择一个区域')
        return
      }
      this.$emit('handleSubmit', {
        custom: this.custom,
        selectedCityIds: this.selectedCityIds,
        selectedText: this.getSelectedText()
      })
      this.handleCancel()
    },
    getSelectedText() {
      const { regions, citysCount, selected, selectedCityIds } = this
      const textData = []
      if (selectedCityIds.length === citysCount) {
        return [{ name: '全国', citys: [] }]
      }
      for (const pidx in selected) {
        const province = selected[pidx]
        const citys = []
        if (province.city.length !== Object.keys(regions[pidx].city).length) {
          for (const cidx in province.city) {
            const city = province.city[cidx]
            citys.push({ name: city.name })
          }
        }
        textData.push({ name: province.name, citys })
      }
      return textData
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.areas-content {
  display: flex;
  justify-content: space-between;

  .areas-left,
  .areas-right {
    width: 48%;
    padding: 0 10px;
  }

  .areas-title {
    font-size: 14px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .areas-flip {
      color: #409eff;
      font-size: 12px;
      cursor: pointer;
    }
  }

  .areas-list {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    height: 450px;
    overflow-y: auto;
    padding: 10px;
    background: #fff;

    .areas-list-body,
    .areas-sublist {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .areas-item {
      margin-bottom: 8px;
      cursor: pointer;

      .text {
        padding-left: 20px;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      &.show-children .icon {
        transform: rotate(90deg);
      }

      .icon {
        position: absolute;
        font-size: 12px;
        transition: transform 0.3s ease-in-out;
        left: 5px;
        top: 50%;
        transform: translateY(-50%);
      }

      .item-title {
        font-size: 14px;
      }

      .item-flip {
        font-size: 12px;
        color: #409eff;
        cursor: pointer;
      }

      .areas-sublist {
        padding-top: 8px;

        .areas-item {
          padding-left: 10px;
          color: #606266;

          .item-title {
            font-size: 13px;
          }
        }
      }
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>